module.exports = __webpack_public_path__ + "img/5.f4310001.jpg";